module.exports = "<div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/error-widget/error-widget.html
// module id = 455
// module chunks = 0